import { Config } from "../service/config"

export const SiteUtil = {
    localiseImgUrl: function (url) {
        return url.replace("[SITE]", Config.SiteUrl)
    }
}